import { CardContentWrapper } from "~/ui/components/cardContent.wrapper";

export const StatCard = ({ title, value }: { title: string; value: string | number }) => {
  return (
    <CardContentWrapper
      hasDivider={false}
      className="flex flex-col items-center justify-center py-4 px-2"
    >
      <p className="text-3xl font-bold text-text-primary">{value}</p>
      <p className="text-sm/4 text-center font-normal text-text-primary">{title}</p>
    </CardContentWrapper>
  );
};
